module.exports = __webpack_public_path__ + "static/media/visit-to-unilag-13.2f7db95f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Experience/Events/visit-to-unilag-13.jpg
// module id = 804
// module chunks = 0